import type { RefObject } from 'react';
import { useCallback } from 'react';
import { trackPageTimeSpent } from '../telemetry/pageTelemetry';
import type { SurveyPaginationRefs } from '../types';

export function useTrackPageTime(paginationRefs: RefObject<SurveyPaginationRefs>) {
  return useCallback(
    (pageIndex: number) => {
      if (!paginationRefs.current) return;
      const durationMs = performance.now() - paginationRefs.current.pageStartTime;
      trackPageTimeSpent(pageIndex, durationMs);
    },
    [paginationRefs]
  );
}
